/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const BankAccountVerificationStatus = {
  New: "new",
  SentCredit: "sent-credit",
  MaxAttemptsExceeded: "max-attempts-exceeded",
  Failed: "failed",
  Expired: "expired",
  Successful: "successful",
} as const;
export type BankAccountVerificationStatus = ClosedEnum<
  typeof BankAccountVerificationStatus
>;

/** @internal */
export const BankAccountVerificationStatus$inboundSchema: z.ZodNativeEnum<
  typeof BankAccountVerificationStatus
> = z.nativeEnum(BankAccountVerificationStatus);
/** @internal */
export const BankAccountVerificationStatus$outboundSchema: z.ZodNativeEnum<
  typeof BankAccountVerificationStatus
> = BankAccountVerificationStatus$inboundSchema;
